import React, {useState} from 'react'
import './StatementAccount.css';

export default function StatementAccount({ account, hasRun, exporting}) {
    const [selected, setSelected] = useState(true)
  return (
    <div className={hasRun ? 'run' : 'notrun'}>{account.AgencyName}{hasRun ? ' - Exported' : exporting ? ' - Exporting...' : ''}</div>
  )
}
